import React, { Component } from "react";
import "./App.css";
import { translations } from "./containers/assets/translations";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import Header from "./containers/Header";
import Footer from "./containers/Footer";
import MainAppContainer from "./containers/MainAppContainer";
import ConfirmOpenTicket from "./containers/ConfirmOpenTicket";
import BusReservations from "./containers/BusReservations";
import Login from "./components/Login";
import ChangePassword from "./components/ChangePassword";
import Logout from "./components/Logout";
import NotFound from "./components/NotFound";
import AppliedRoute from "./components/AppliedRoute";

export default class App extends Component {
  // The App Component includes the building blocks of the application and modifies critical app data.
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
    localStorage.setItem("lang", "EN");
    this.state = {
      isAuthenticated: "false",
      lang: "EN",
      port: null,
      lastScannedMRZ: null,
    };
    this.checkExistingConnection();
  }

  checkExistingConnection = async () => {
    try {
      const ports = await navigator.serial.getPorts();
      if (ports.length > 0) {
        const port = ports[0];
        await port.open({
          baudRate: 9600,
          dataBits: 8,
          stopBits: 1,
          parity: "none",
          bufferSize: 255,
        });
        this.setPort(port);
      }
    } catch (error) {
      console.log("Error checking connection:", error);
    }
  };

  userHasAuthenticated = () => {
    this.setState({ isAuthenticated: "true" });
  };

  handleLogout = () => {
    this.setState({ isAuthenticated: "false" });
    localStorage.setItem("Authenticated", "false");
    localStorage.setItem("userGroupCode", "");
    localStorage.setItem("password", "");
    localStorage.setItem("code", "");
  };

  selectLanguage = (event) => {
    let selectedLanguage = event.target.value;
    selectedLanguage =
      selectedLanguage === "EN" ||
      selectedLanguage === "FR" ||
      selectedLanguage === "ES"
        ? selectedLanguage
        : "EN";
    localStorage.setItem("lang", selectedLanguage);
    this.setState({ lang: selectedLanguage });
  };

  setPort = (port) => {
    this.setState({ port }, () => {
      this.startGlobalReading();
    });
  };

  onRequestPort = async () => {
    try {
      const port = await navigator.serial.requestPort();
      await port.open({
        baudRate: 9600,
        dataBits: 8,
        stopBits: 1,
        parity: "none",
        bufferSize: 255,
      });
      this.setPort(port);
    } catch (error) {
      console.error("Failed to request port:", error);
    }
  };

  startGlobalReading = async () => {
    if (!this.state.port || !this.state.port.readable) return;
    if (this.state.port.readable.locked) return;

    let accumulatedData = "";
    let isCapturing = false;

    try {
      const reader = this.state.port.readable.getReader();
      try {
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const decodedData = new TextDecoder().decode(value);
          for (let char of decodedData) {
            if (char === "\x02") {
              isCapturing = true;
              accumulatedData = "";
              continue;
            }
            if (char === "\x03") {
              isCapturing = false;
              this.setState({
                lastScannedMRZ: {
                  data: accumulatedData,
                  timestamp: Date.now(),
                },
              });
              break;
            }
            if (isCapturing) accumulatedData += char;
          }
        }
      } finally {
        reader.releaseLock();
      }
    } catch (error) {
      console.error("Global reading error:", error);
    }
  };

  render() {
    const bgrEnabled = process.env.REACT_APP_BGR_ENABLED === "true";
    const canSeeBusGroups = bgrEnabled && localStorage.getItem("CanListViewBGR") === "true";

    let userOptionsContainer =
      this.state.isAuthenticated === "true" ? (
        <div
          className="navigationBar"
          style={{ marginLeft: "auto" }}
          onClick={this.handleLogout}
        >
          <div className="links">
            <Link className="links" to={"/logout"}>
              {translations[this.state.lang]["Logout"]}
            </Link>
          </div>
        </div>
      ) : null;

    /* <LinkContainer to="/change_password">
            <NavItem className="links">
              {translations[this.state.lang]["Change Password"]}
            </NavItem>
          </LinkContainer> */

    let routeProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      lang: this.state.lang,
      userLanguage: this.selectLanguage,
      port: this.state.port,
      setPort: this.setPort,
      onRequestPort: this.onRequestPort,
      lastScannedMRZ: this.state.lastScannedMRZ,
    };

    return (
      <div>
        <Header 
          loggedIn={this.state.isAuthenticated} 
          port={this.state.port}
          onRequestPort={this.onRequestPort}
          lang={this.state.lang}
        />
        <Navbar fluid collapseOnSelect>
          <Navbar.Header style={{ width: "100%" }}>
            <div>
              {this.state.isAuthenticated === "true" ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="navigationBar">
                    <Link className="links" to={"/home"}>
                      {translations[this.state.lang]["Home"]}
                    </Link>
                  </div>
                  <div className="navigationBar">
                    <Link className="links" to={"/confirm_tickets"}>
                      {translations[this.state.lang]["Confirm Open Tickets"]}
                    </Link>
                  </div>

                  {canSeeBusGroups && (
                    <div className="navigationBar">
                      <Link className="links" to={"/bus_reservations"}>
                        {translations[this.state.lang]["Bus Reservations"]}
                      </Link>
                    </div>
                  )}

                  {userOptionsContainer}
                </div>
              ) : (
                <div className="navigationBar">
                  <Link className="links" to={"/"}>
                    {translations[this.state.lang]["Login"]}
                  </Link>
                </div>
              )}
            </div>
          </Navbar.Header>
        </Navbar>
        <Switch>
          <AppliedRoute
            path="/home"
            exact
            component={MainAppContainer}
            props={routeProps}
          />
          <AppliedRoute
            path="/change_password"
            exact
            component={ChangePassword}
            props={routeProps}
          />
          <AppliedRoute
            path="/logout"
            exact
            component={Logout}
            props={routeProps}
          />
          <AppliedRoute path="/" exact component={Login} props={routeProps} />
          <AppliedRoute
            path="/confirm_tickets"
            exact
            component={ConfirmOpenTicket}
            props={routeProps}
          />
          <AppliedRoute
            path="/bus_reservations"
            exact
            component={BusReservations}
            props={routeProps}
          />
          <Route component={NotFound} props={routeProps} />
        </Switch>
        {/* <Footer /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js